import styled from 'styled-components';
import { Button } from 'antd';
import { COLORS, FONTS, STYLES } from 'utils/constants/styles';
import { ComponentProps } from 'react';
import DownloadImage from '../../../assets/img/download.svg';
import DownloadFileImage from '../../../assets/img/download-file.svg';
import UploadFile from '../../../assets/img/upload.svg';

const StyledButton = styled(Button)`
    white-space: initial;
    height: auto;
    color: ${props => props.theme.text.black} !important;
    padding: ${STYLES.BUTTON_PADDING};
    font-weight: ${FONTS.MEDIUM};
    font-size: ${FONTS.DESCRIPTION_FONT_SIZE};
    line-height: ${FONTS.DESCRIPTION_FONT_SIZE};
    border: none;
    display: flex;
    gap: 16px;
    align-items: center;
    background: transparent;

    span {
        text-decoration: underline;
    }

    &:hover,
    &:active,
    &:focus {
        color: ${props => props.theme.text.black} !important;
        border: none;
    }
`;

type Props = ComponentProps<typeof StyledButton> & {
    type: 'download-file' | 'download' | 'upload';
    width?: number;
    height?: number;
};

const getIcon = (type: 'download-file' | 'download' | 'upload') => {
    switch (type) {
        case 'download':
            return DownloadImage;
        case 'download-file':
            return DownloadFileImage;
        case 'upload':
            return UploadFile;
        default:
            return DownloadImage;
    }
};

const FileButton = ({ type, width, height, children, ...passThroughProps }: Props) => (
    <StyledButton {...passThroughProps}>
        <img width={width || 61} height={height || 71} src={getIcon(type)} alt={type} />
        {children}
    </StyledButton>
);

export default FileButton;
